import AsyncAutocomplete from "./AsyncAutocomplete";
import { searchZones } from "../../api/ZoneService";

const fetchZonePage = async (page, search) => {
  const res = await searchZones({ page, search, perPage: 50 });
  const paginator = res?.data ?? {};
  return {
    items: Array.isArray(paginator.data) ? paginator.data : [],
    hasMore: (paginator.current_page || 1) < (paginator.last_page || 1),
  };
};

/**
 * Searchable, infinite-scrolling zone picker. Controlled by zone id.
 */
export default function ZoneSelect({ label = "Zone", ...props }) {
  return <AsyncAutocomplete label={label} fetchPage={fetchZonePage} {...props} />;
}
